import no_data from "../Assets/img/no_data.svg";

const NoData = ({text}) => {
    return (
        <div className="py-24 flex justify-center flex-col items-center">
            <img className="w-64" src={no_data} alt="No Data" />
            <h1 className="text-xl font-medium py-2 text-gray-400">
                {text}
            </h1>
        </div>
    )
}

export default NoData;